jQuery(function () {

	// Don't run if we are not one of the
	// WPM main tabs
	if ("wpm" !== wpmGetPageId()) return

	let sections    = []
	let subsections = {}

	// Hide unnecessary elements
	jQuery(".section").closest("tr").hide()

	// Collect information on sections
	jQuery(".section").each(function () {
		sections.push({
			"slug" : jQuery(this).data("sectionSlug"),
			"title": jQuery(this).data("sectionTitle"),
		})
	})

	// Collect information on subsections
	jQuery(".subsection").each(function () {

		subsections[jQuery(this).data("sectionSlug")] = subsections[jQuery(this).data("sectionSlug")] || []

		subsections[jQuery(this).data("sectionSlug")].push({
			"title": jQuery(this).data("subsectionTitle"),
			"slug" : jQuery(this).data("subsectionSlug"),
		})
	})

	// Create tabs for sections
	sections.forEach(
		function (section) {
			jQuery(".nav-tab-wrapper").append("<a href=\"#\" class=\"nav-tab\" data-section-slug=\"" + section["slug"] + "\">" + section["title"] + "</a>")
		})

	// Create tabs for each subsections
	jQuery(".nav-tab-wrapper").after(wpmCreateSubtabUlHtml(subsections))

	// Create on-click events on section tabs that toggle the views
	jQuery(".nav-tab-wrapper a").on("click", function (e) {

		e.preventDefault()

		// show clicked tab as active
		jQuery(this).addClass("nav-tab-active").siblings().removeClass("nav-tab-active")

		// toggle the sections visible / invisible based on clicked tab

		let sectionSlug = jQuery(this).data("section-slug")
		wpmToggleSections(sectionSlug, sections)

		// if subsection exists, click on first subsection
		if (sectionSlug in subsections) {
			jQuery("ul[data-section-slug=" + sectionSlug + "]").children(":first").trigger("click")
		}
	})

	// Create on-click events on subsection tabs that toggle the views
	jQuery(".pmw-subnav-li").on("click", function (e) {

		e.preventDefault()
		e.stopPropagation()

		// jQuery(this).hide();
		jQuery(this)
			.addClass("pmw-subnav-li-active").removeClass("pmw-subnav-li-inactive")
			.siblings()
			.addClass("pmw-subnav-li-inactive").removeClass("pmw-subnav-li-active")

		wpmToggleSubsection(jQuery(this).parent().data("section-slug"), jQuery(this).data("subsection-slug"))
	})

	/**
	 * If someone accesses a plugin tab by deep link, open the right tab
	 * or fallback to default (first tab)
	 *
	 * If deeplink is being opened,
	 * open the according section and subsection
	 */
	if (wpmGetSectionParams()) {

		let sectionParams = wpmGetSectionParams()

		jQuery("a[data-section-slug=" + sectionParams["section"] + "]").trigger("click")

		if (sectionParams["subsection"] !== false) {
			jQuery("ul[data-section-slug=" + sectionParams["section"] + "]").children("[data-subsection-slug=" + sectionParams["subsection"] + "]").trigger("click")
		}
	} else {
		jQuery("a[data-section-slug=" + sections[0]["slug"] + "]").trigger("click")
	}
})

// Creates the html with all subsection elements
wpmCreateSubtabUlHtml = (subsections) => {

	let subsectionsKeys = Object.keys(subsections)

	let html = ""

	subsectionsKeys.forEach(function (subsectionKey) {
		html += "<ul class=\"pmw-subnav-tabs\" data-section-slug=\"" + subsectionKey + "\">"

		let subtabs = subsections[subsectionKey]

		subtabs.forEach(function (subtab) {
			html += "<li class=\"pmw-subnav-li pmw-subnav-li-inactive\" style=\"cursor: pointer;\" data-subsection-slug=\"" + subtab["slug"] + "\">" + subtab["title"] + "</li>"
		})

		html += "</ul>"
	})

	return html
}

/**
 * If section (and subsection) URL parameters are set,
 * return them, otherwise return false
 */
wpmGetSectionParams = () => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	if (urlParams.get("section")) {
		return {
			"section"   : urlParams.get("section"),
			"subsection": urlParams.get("subsection"),
		}
	} else {
		return false
	}
}

// Toggles the sections
wpmToggleSections = (sectionSlug, sections) => {

	jQuery("#wpm_settings_form > h2").nextUntil(".submit").andSelf().hide()
	jQuery(".pmw-subnav-tabs").hide()
	jQuery(".pmw-subnav-tabs[data-section-slug=" + sectionSlug + "]").show()

	let sectionPos = sections.findIndex((arrayElement) => arrayElement["slug"] === sectionSlug)

	jQuery("div[data-section-slug=" + sectionSlug + "]").closest("table").prevAll("h2:first").next().nextUntil("h2, .submit").andSelf().show()

	// set the URL with the active tab parameter
	wpmSetUrl(sections[sectionPos]["slug"])
}

const wpmToggleSubsection = (sectionSlug, subsectionSlug) => {

	jQuery("#wpm_settings_form > h2").nextUntil(".submit").andSelf().hide()
	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("tr").siblings().andSelf().hide()

	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("table").show()
	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("tr").nextUntil(jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug]").closest("tr")).show()

	// Set the URL with the active tab parameter
	wpmSetUrl(sectionSlug, subsectionSlug)
}

// Sets the new URL parameters
wpmSetUrl = (sectionSlug, subsectionSlug = "") => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	urlParams.delete("section")
	urlParams.delete("subsection")

	let newParams = "section=" + sectionSlug
	newParams += subsectionSlug ? "&subsection=" + subsectionSlug : ""

	history.pushState("", "wpm" + sectionSlug, document.location.pathname + "?page=wpm&" + newParams)

	// Make WP remember which was the selected tab on a save and return to the same tab after saving
	jQuery("input[name =\"_wp_http_referer\"]").val(wpmGetAdminPath() + "?page=wpm&" + newParams + "&settings-updated=true")
}

wpmGetAdminPath = () => {
	let url = new URL(jQuery("#wp-admin-canonical").attr("href"))
	return url.pathname
}

wpmGetPageId = () => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	return urlParams.get("page")
}

// On click of an element that contains a data-section-slug with any value show an alert box with the text hello
jQuery(document).on("click", "[data-section-slug]", function () {

	const infoTabs = [
		"opportunities",
		"diagnostics",
		"support",
	]

	// If the data-section-slug value is one of infoTabs, hide the save button, otherwise show it
	if (infoTabs.includes(jQuery(this).data("section-slug"))) {
		// Hide the element with class submit
		jQuery(".submit").hide()
	} else {
		// Show the element with class submit
		jQuery(".submit").show()
	}
})


// On click of an element that contains the classes pmw, opportunity and dismiss show an alert box with the text hello
jQuery(document).on("click", ".pmw.opportunity-dismiss", function () {

	// Move the parent element that contains the class pmw and opportunity and card and move it to the div with id pmw-dismissed-opportunities
	jQuery(this).closest(".pmw.opportunity-card").appendTo("#pmw-dismissed-opportunities")
	// Remove the element with the class opportunity-dismiss
	jQuery(this).closest(".opportunity-dismiss").remove()
})

// if a link with the class advanced-section-link is clicked,
// get the data-AS-section and the data-AS-subsection values of the clicked element
// and trigger a click on the element with the data-ssection-slug value and a click on the element with the data-subsection-slug value
jQuery(document).on("click", ".advanced-section-link", (e) => {

	e.preventDefault()

	let sectionSlug    = jQuery(e.currentTarget).data("as-section")
	let subsectionSlug = jQuery(e.currentTarget).data("as-subsection")

	jQuery(`a[data-section-slug=${sectionSlug}]`).trigger("click")

	jQuery(`ul[data-section-slug=${sectionSlug}]`).children(`[data-subsection-slug=${subsectionSlug}]`).trigger("click")
})
